import { Component, OnInit, } from '@angular/core';
import { APP_CONSTANTS } from 'src/app/constants/constants';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
	selector: 'app-ai-governance-dashboard',
	templateUrl: './ai-governance-dashboard.component.html',
	styleUrls: ['./ai-governance-dashboard.component.scss']
})
export class AiGovernanceDashboardComponent implements OnInit {
	
	APP_CONSTANTS = APP_CONSTANTS;

	user_details: any;

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");
		this.getPageData();
	}

	user_type: any = "client";
	page_data: any = [];
	page_data_loaded: boolean = false;
	getPageData() {
		this.page_data_loaded = false;
		this.commonService.getData("/aigovernanceengagement/?user_type=" + this.user_type).subscribe(
			(res: any) => {
				this.page_data = res["data"];
				this.page_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	show_user_profile: boolean = false;
	user_profile_data: any;
	user_profile_data_type: any = "";
	showUserProfile(data) {
		if (this.user_type == 'client') {
			this.user_profile_data_type = "Client";
		} else {
			this.user_profile_data_type = "Lead";
		}

		this.user_profile_data = JSON.parse(JSON.stringify(data));
		this.show_user_profile = true;
	}


	profileClosed(event) {
		this.user_profile_data = {};
		this.show_user_profile = false;
		this.user_profile_data_type = "";
	}

	show_all_first_table_data: boolean = false;
	show_all_second_table_data: boolean = false;
	show_all_third_table_data: boolean = false;

	getLimit(value, data) {
		if (value == true) {
			return data.length;
		} else {
			return 5;
		}
	}

	addManualTask(user) {
		let data: any = {
			id: null,
			parent_activity: null,
			activity_type: user.activity_type_id,
			source: null,
			activity_communication_type: user.recommended_actions
		};

		

		this.showActivityDetails(data);
	}

	show_activity_data: boolean = false;
	activity_user_data: any = {};
	selected_activities_list: any = [];
	showActivityDetails(data) {
		this.activity_user_data.client = data.id;
		if (this.user_type == "prospect") {
			this.activity_user_data.is_client = false;
		}
		this.show_activity_data = true;
		this.selected_activities_list.push(JSON.parse(JSON.stringify(data)));
    }

	activityDetailsClosed(event) {
		this.show_activity_data = false;
		this.activity_user_data = {};
		this.selected_activities_list = [];
		this.getPageData();
	}

	addActivity(data) {
		const payload = {
			id: data.id,
			user_type: this.user_type,
			recommended_actions: data.recommended_actions,
		};
		this.commonService.postData("/updateengagementstatus/", payload).subscribe(
			(res: any) => {
				this.commonService.showToast('success', "Task created successfully. The record has been moved to Action Items and removed from Advisor Action Required.");
				this.getPageData();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}
}
